import React, { useState, useEffect } from 'react';
import './css/DailyReport.css'
import api from '../api/api';
import { useNavigate,useLocation } from 'react-router-dom';


const DailyReportSettings = ({handleCloseClick}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [companies, setCompanies] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('日産自動車を削除しました');
    const [enteredCompanyName, setEnteredCompanyName] = useState('');

    const fetchDailyReportList = async () => {
        try {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/registered-companies/`);
            setCompanies(response.data);
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                navigate('/login', { state: { from: location.pathname } });
            } else {
                console.error('Error fetching registered companies:', error);
            }
        } finally {
        }
    };

    useEffect(() => {
        fetchDailyReportList();
    }, [])

    const removeCompany = async (secCode, companyName) => {
        try {
            // APIリクエストでsecCodeを使って会社を削除
            await api.delete(`${process.env.REACT_APP_API_URL}/chat/api/registered-companies/`, {
                data: { sec_code: secCode } // DELETEリクエストのボディにsec_codeを渡す
            });
            
            setModalMessage(`${companyName}の登録を解除しました`);
            setShowDeleteModal(true);
            
            // 削除が成功したら、フロントエンドの状態からも削除
            setCompanies(companies.filter(company => company.sec_code !== secCode));
            
            // 2秒後にモーダルを非表示にする
            setTimeout(() => {
                setShowDeleteModal(false);
            }, 1000);
        } catch (error) {
            console.error(`Error removing company with sec_code ${secCode}:`, error);
        }
    };

    const addCompany = async () => {
        if (enteredCompanyName.trim() !== '') {
            try {
                // APIリクエストで会社を追加
                const response = await api.post(`${process.env.REACT_APP_API_URL}/chat/api/registered-companies/`, {
                    company_name: enteredCompanyName
                });
                
                setModalMessage(`${response.data.company_name} (${response.data.sec_code}) を登録しました`);
                setShowAddModal(true);
                
                // 追加が成功したら、フロントエンドの状態を更新
                setCompanies([...companies, response.data]);

                // 2秒後にモーダルを非表示にする
                setTimeout(() => {
                    setShowAddModal(false);
                }, 1000);
            } catch (error) {
                console.error(`Error adding company with sec_code ${enteredCompanyName}:`, error);
            }      
        }
    };
    
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            addCompany();
            setEnteredCompanyName('');
        }
    }

    return (
        <div className="daily-report-settings-modal-overlay">
            <div className="daily-report-settings-modal">
                {(showDeleteModal || showAddModal) && (
                    <div className={`message-modal ${showAddModal ? "add-message-modal" : ""} ${showDeleteModal ? "delete-message-modal" : ""}`} >
                        <p>{modalMessage}</p>
                    </div>
                )}
                <span className='daily-report-settings-close-btn close' onClick={handleCloseClick}>×</span>
                <h2 className="daily-report-settings-modal-title">デイリーレポートを受け取るに設定している企業</h2>
                <div className="daily-report-settings-company-list">
                    {companies.map((company) => (
                        <div key={company.sec_code} className="daily-report-settings-company-item">
                            <span className="daily-report-settings-company-code">{company.sec_code}</span>
                            <span className="daily-report-settings-company-name">{company.company_name}</span>
                            <button className="daily-report-settings-remove-button" onClick={() => removeCompany(company.sec_code, company.company_name)}>×</button>
                        </div>
                    ))}
                </div>
                <div className="daily-report-settings-search-container">
                <input 
                    type="text" 
                    placeholder="企業を追加" 
                    className="daily-report-settings-search-input" 
                    value={enteredCompanyName}
                    onChange={(e) => setEnteredCompanyName(e.target.value)}
                    onKeyDown={handleKeyDown}
                    />
                <button className="daily-report-settings-add-button" onClick={addCompany}>+</button>
                </div>
            </div>
        </div>
      );
}

export default DailyReportSettings